import { CATEGORIES } from "./assets/background";

export const songs = [
  "01 - AI Theme I.mp3",
  "02 - AI Theme II.mp3",
  "03 - AI Theme III.mp3",
  "04 - Battle Defeat.mp3",
  "05 - Battle Retreat.mp3",
  "06 - Battle Surrender.mp3",
  "07 - Battle Victory.mp3",
  "08 - Campaign Defeat.mp3",
  "09 - Campaign Theme - Armageddon's Blade.mp3",
  "10 - Campaign Theme - Dragon Slayer.mp3",
  "11 - Campaign Theme - Dragon's Blood.mp3",
  "12 - Campaign Theme - Festival of Life.mp3",
  "13 - Campaign Theme - Foolhardy Waywardness.mp3",
  "14 - Campaign Theme - Playing With Fire.mp3",
  "15 - Campaign Theme I.mp3",
  "16 - Campaign Theme II.mp3",
  "17 - Campaign Theme III.mp3",
  "18 - Campaign Theme IV.mp3",
  "19 - Campaign Theme IX.mp3",
  "20 - Campaign Theme V.mp3",
  "21 - Campaign Theme VI.mp3",
  "22 - Campaign Theme VII.mp3",
  "23 - Campaign Theme VIII.mp3",
  "24 - Campaign Theme X.mp3",
  "25 - Campaign Theme XI.mp3",
  "26 - Combat I.mp3",
  "27 - Combat II.mp3",
  "28 - Combat III.mp3",
  "29 - Combat IV.mp3",
  "30 - Evil Theme.mp3",
  "31 - Good Theme.mp3",
  "32 - Leprechaun Loop.mp3",
  "33 - Main Theme.mp3",
  "34 - Neutral Theme.mp3",
  "35 - Scenario Victory.mp3",
  "36 - Secret Theme.mp3",
  "37 - Siege Defeat.mp3",
  "38 - Siege Victory.mp3",
  "39 - Terrain - Dirt.mp3",
  "40 - Terrain - Grass.mp3",
  "41 - Terrain - Lava.mp3",
  "42 - Terrain - Rough.mp3",
  "43 - Terrain - Sand.mp3",
  "44 - Terrain - Snow.mp3",
  "45 - Terrain - Swamp.mp3",
  "46 - Terrain - Underground.mp3",
  "47 - Terrain - Water.mp3",
  "48 - Town - Castle.mp3",
  "49 - Town - Conflux.mp3",
  "50 - Town - Dungeon.mp3",
  "51 - Town - Fortress.mp3",
  "52 - Town - Inferno.mp3",
  "53 - Town - Necropolis.mp3",
  "54 - Town - Rampart.mp3",
  "55 - Town - Stronghold.mp3",
  "56 - Town - Tower.mp3",
  "57 - Ultimate Defeat.mp3",
] as const;

export const songBackgrounds: { [K in (typeof songs)[number]]?: CATEGORIES } = {
  "39 - Terrain - Dirt.mp3": CATEGORIES.dirt,
  "40 - Terrain - Grass.mp3": CATEGORIES.grass,
  "41 - Terrain - Lava.mp3": CATEGORIES.lava,
  "42 - Terrain - Rough.mp3": CATEGORIES.rough,
  "43 - Terrain - Sand.mp3": CATEGORIES.sand,
  "44 - Terrain - Snow.mp3": CATEGORIES.snow,
  "45 - Terrain - Swamp.mp3": CATEGORIES.swamp,
  "46 - Terrain - Underground.mp3": CATEGORIES.under,
  "47 - Terrain - Water.mp3": CATEGORIES.water,

  "48 - Town - Castle.mp3": CATEGORIES.CASTLE,
  "49 - Town - Conflux.mp3": CATEGORIES.CONFLUX,
  "50 - Town - Dungeon.mp3": CATEGORIES.DUNGEON,
  "51 - Town - Fortress.mp3": CATEGORIES.FORTRESS,
  "52 - Town - Inferno.mp3": CATEGORIES.INFERNO,
  "53 - Town - Necropolis.mp3": CATEGORIES.NECROPOLIS,
  "54 - Town - Rampart.mp3": CATEGORIES.RAMPART,
  "55 - Town - Stronghold.mp3": CATEGORIES.STRONGHOLD,
  "56 - Town - Tower.mp3": CATEGORIES.TOWER,
};
